import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header, { isDarkRoute } from "../components/Header";
import Footer from "../components/Footer";

// Scroll to the hash target (e.g. /#services) after navigation, otherwise to top.
const useScrollToHash = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.getElementById(hash.slice(1));
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0 });
    }, [pathname, hash]);
};

const RootLayout = () => {
    useScrollToHash();
    const { pathname } = useLocation();
    // Product landing pages are dark, so the strip under the floating header must be too.
    const dark = isDarkRoute(pathname);

    return (
        <div className={`flex min-h-screen flex-col ${dark ? "bg-dark" : "bg-white"}`}>
            <Header />
            {/* The header floats over the page, so pages start below its 110px (80px on mobile). */}
            <main className="flex-1 pt-[80px] md:pt-[110px]">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default RootLayout;
